import React from "react";
import { ImportHelperTable } from "../component";
export const ImportHelper: React.FC = () => <ImportHelperTable />;
